import DataSourceInstances from '@/components/dataSource/dataSourceInstances';
import { Box } from '@mui/material';

type Props = { maxHeight: number };
const MyDataSourceInstances = ({ maxHeight }: Props) => {
  return (
    <Box sx={{ height: `${maxHeight}px` }}>
      <DataSourceInstances />
    </Box>
  );
};

export default MyDataSourceInstances;
